import { compact } from 'lodash';
import { ExpandableListItem } from '@components/material-ui';
import { TourInformation as ToursInformationType } from '@model/tours';
import { TestId } from '@components/test-ids';
import { useI18NextContext } from '@components/hooks';
import { SectionTitle } from '@components/common/section-title';
import { ExpandableListGroupItem } from '@model/common';
import React from 'react';

export interface TourInformationProps {
  tourInformation?: ToursInformationType;
  testId?: string;
  heading: string;
}

export const TourInformation = (props: TourInformationProps) => {
  const t: any = useI18NextContext();
  const { tourInformation, testId, heading } = props;

  if (!tourInformation) {
    return null;
  }
  const items: Array<ExpandableListGroupItem | null> = Object.entries(tourInformation).map(([key, value]: any) => {
    return typeof value === 'string'
      ? {
          title: t(`tour__information-title--${key}`),
          text: value
        }
      : null;
  });

  return (
    <div data-testid={testId || TestId.tourInformation.main}>
      <SectionTitle heading={heading} />
      <div>
        <ExpandableListItem items={compact(items)} />
      </div>
    </div>
  );
};
